<template>
  <div class="editProfileNew">
    <van-form
      ref="validateForm"
      validate-first
      input-align="right"
      :show-error="false"
      :show-error-message="false"
    >
      <van-field
        required
        rows="1"
        autosize
        type="textarea"
        v-model.trim="userInfo.name"
        label="姓名"
        placeholder="请输入姓名"
        :rules="[{ validator: nameValidator, message: '请输入姓名' }]"
        maxlength="15"
      />
      <van-field
        label="性别"
        placeholder="请选择性别"
      >
        <template #input>
          <van-radio-group v-model="userInfo.sex" direction="horizontal">
            <van-radio :name="1">男</van-radio>
            <van-radio :name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        rows="1"
        autosize
        type="textarea"
        v-model.trim="userInfo.age"
        label="年龄"
        oninput="if(value>999){value=999}else{value=value.replace(/[^\d]/g,'')}if(value.indexOf(0)==0){value=0}"
      />
      <van-field
        rows="1"
        autosize
        type="textarea"
        v-model.trim="userInfo.nationality"
        label="国籍"
        placeholder="请输入国籍"
      />
      <van-field
          disabled
          name="picker"
          :value="cardTypeName"
          label="证件类型"
          placeholder="点击选择证件类型"
        />
      <!-- <van-popup v-model="showcardTypePicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="cardTypeList"
          @confirm="onCardTypeConfirm"
          @cancel="showcardTypePicker = false"
        />
      </van-popup> -->
      <van-field
        required
        v-model.trim="userInfo.idCard"
        label="证件号"
        disabled
      >
        <template v-if="!userInfo.idCard" #button>
          <van-button size="small" type="primary" color="#1972ff" @click="toIdentify">前往身份认证</van-button>
        </template>
      </van-field>
      <van-field
        required
        autosize
        rows="1"
        disabled
        type="textarea"
        v-model.trim="userInfo.phone"
        label="联系电话"
        :rules="[{ validator, message: '联系电话格式不正确' }]"
      />
      <van-field
        rows="1"
        autosize
        type="textarea"
        v-model.trim="area"
        label="联系地址"
        @click="showArea = true"
      />
      <van-popup v-model="showArea" position="bottom">
        <van-area
          :area-list="areaList"
          @confirm="onShowAreaConfirm"
          @cancel="showArea = false"
        />
      </van-popup>
      <van-field
        rows="1"
        autosize
        type="textarea"
        v-model.trim="userInfo.postCode"
        label="邮政编码"
        :rules="[{ validator:postValidator, message: '邮政编码格式不正确' }]"
      />
      <!-- <van-field
        rows="1"
        autosize
        label="照片"
        class="jiaotong-img"
      >
        <template #input>
          <van-image
            width="100px"
            height="100px"
            :src="userInfo.photo"
          />
        </template>
      </van-field> -->
      <van-field
          readonly
          clickable
          name="picker"
          :value="apCategoryOptions[userInfo.apCategory]"
          label="申请培训类别"
          placeholder="点击选择申请培训类别"
          @click="showApCategoryPicker = true"
      />
      <van-popup v-model="showApCategoryPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="apCategoryList"
          @confirm="onApCategoryConfirm"
          @cancel="showApCategoryPicker = false"
        />
      </van-popup>
      <van-field
        rows="1"
        autosize
        type="textarea"
        v-model.trim="drTypeOptions[userInfo.drType]"
        label="驾驶证准驾车型"
        @click="showDrTypePicker = true"
      />
      <van-popup v-model="showDrTypePicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="drTypeList"
          @confirm="onDrTypeConfirm"
          @cancel="showDrTypePicker = false"
        />
      </van-popup>
      <van-field
        rows="1"
        autosize
        type="textarea"
        v-model.trim="userInfo.iauthority"
        label="从业资格证发证机关"
      />
      <van-field
        rows="1"
        autosize
        type="textarea"
        v-model.trim="userInfo.qcNumber"
        label="从业资格证件号码"
      />
      <van-field
        rows="1"
        autosize
        type="textarea"
        v-model.trim="userInfo.cvalidity"
        label="从业资格证有效期至"
        @click="showMonthRangePicker = true"
      />
      <van-popup v-model="showMonthRangePicker" position="bottom">
        <van-calendar
          v-model="showMonthRangePicker"
          type="range"
          @confirm="onMonthRangeConfirm"
        />
      </van-popup>
      <!-- <van-field
        rows="1"
        autosize
        type="textarea"
        v-model.trim="userTypeOptions[userInfo.userType]"
        label="用户类型"
        disabled
      /> -->
      <van-field
        rows="1"
        autosize
        type="textarea"
        v-model.trim="userInfo.insName"
        label="所属（服务）单位名称"
      />
      <!-- <van-field
        rows="1"
        autosize
        type="textarea"
        v-model.trim="userInfo.insCode"
        label="所属（服务）单位编号"
      /> -->
      <div class="handle_btn">
        <van-button
          round
          block
          plain
          type="info"
          class="cancel_btn"
          @click="cancelHandle"
          >取消</van-button
        >
        <van-button round block type="info" class="save_btn" @click="saveHandle"
          >保存</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  name: "editProfileNew",
  data() {
    return {
      monthrange:[],
      userInfo: {
        id:null,
        stuNum:'',//编号
        name:'',//姓名
        sex:'',//性别
        age:'',//年龄
        nationality:'',//国籍
        cardType:'',//证件类型
        idCard:'',//证件号
        phone:'',//联系电话
        regionCode:'',//联系地址
        address:'',//联系地址
        apCategory:'',//申请培训类别编号
        drType:'',//驾驶证车型
        postCode:'',//邮政编码
        photo:'',//人像信息
        iauthority:'',//从业资格机关
        qcNumber:'',//从业资格证件号码
        cvalidity:'',//从业资格证有效期
        applyDate:'',//注册时间
        userType:'',//用户类型
        insName:'',//所属企业名称
        insCode:'',//所属企业编号
      },
      area:'',
      areaList: {
				province_list: {},
				city_list: {},
				county_list: {},
			}, // 数据格式见 Area 组件文档
      cardTypeName:'',
      showcardTypePicker:false,
      showApCategoryPicker:false,
      showDrTypePicker:false,
      showMonthRangePicker:false,
      showArea:false,
      cardTypeList:[
        {text:'身份证',value:'1'},
        {text:'护照',value:'2'},
        {text:'军官证',value:'3'},
        {text:'其他',value:'4'},
      ],
      cardTypeOptions:{1:'身份证',2:'护照',3:'军官证',4:'其他'},
      apCategoryList:[
        { value:'0', text:'道路旅客运输'},
        { value:'1', text:'道路货物运输'},
        { value:'2', text:'危险货物道路运输'},
        { value:'3', text:'放射性物品道路运输'},
        { value:'4', text:'机动车检测维修'},
        { value:'5', text:'机动车驾驶培训'},
        { value:'6', text:'出租汽车运输'},
        { value:'7', text:'道路运输主要负责人'},
        { value:'8', text:'城市公共汽电车运输'},
        { value:'9', text:'城市轨道交通运输'},
        { value:'10', text:'其他道路运输'},
      ],
      apCategoryOptions:{
        0:'道路旅客运输',
        1:'道路货物运输',
        2:'危险货物道路运输',
        3:'放射性物品道路运输',
        4:'机动车检测维修',
        5:'机动车驾驶培训',
        6:'出租汽车运输',
        7:'道路运输主要负责人',
        8:'城市公共汽电车运输',
        9:'城市轨道交通运输',
        10:'其他道路运输'
      },
      drTypeList:[
        {text:'A1',value:'0'},
        {text:'A2',value:'1'},
        {text:'A3',value:'2'},
        {text:'B1',value:'3'},
        {text:'B2',value:'4'},
        {text:'C1',value:'5'},
        {text:'C2',value:'6'},
        {text:'C3',value:'7'},
        {text:'C4',value:'8'},
        {text:'C5',value:'9'},
        {text:'无',value:'10'}
      ],
      drTypeOptions:{0:'A1',1:'A2',2:'A3',3:'B1',4:'B2',5:'C1',6:'C2',7:'C3',8:'C4',9:'C5',10:'无'},
      userTypeOptions:{1:'教学资源提供者',2:'教学组织者',3:'远程教育平台运营服务人员',4:'学习者',5:'教学管理者'},
    };
  },
  async created() {
    await this.getRegionList()
  },
  async mounted(){
    this.getData()
  },
  methods: {
    getRegionList() {
			this.$api.usercenter.getTree({ type: 1 }).then((res) => {
				if (res.success && res.data) {
					let filterArr = res.data
					// 切换成vant省市组件格式
					filterArr.map((item) => {
						this.areaList.province_list[item.code] = item.name
						item.children.map((province) => {
							this.areaList.city_list[province.code] = province.name
							;(province.children || []).map((county) => {
								this.areaList.county_list[county.code] = county.name
							})
						})
					})
				}
			})
		},
    async getData() {
      this.$api.user.findByUserId().then((res) => {
        if (res.code == 0 && res.success) {
          this.userInfo = Object.assign({}, this.userInfo, res.data);
          this.cardTypeName = this.cardTypeOptions[this.userInfo.cardType]
          setTimeout(()=>{
            this.remoteMethod(res.data.regionCode)
          },800)
        }
      });
    },
    remoteMethod(code){
      this.area = this.areaList.province_list[code.substr(0,2)] + '-' +
                  this.areaList.city_list[code.substr(0,4)] + '-' +
                  this.areaList.county_list[code];
    },
    toIdentify(){
      this.$router.push('/idcard')
    },
    back(){
        this.$router.go(-1);
    },
    // 证件类型选择
    onCardTypeConfirm(value){
      this.cardTypeName = value.text
      this.userInfo.cardType = value.value
      this.showcardTypePicker = false;
    },
    // 申请类别
    onApCategoryConfirm(value){
      this.userInfo.apCategory = value.value;
      this.showApCategoryPicker = false;
    },
    // 准驾车型
    onDrTypeConfirm(value){
      this.userInfo.drType = value.value;
      this.showDrTypePicker = false
    },
    onShowAreaConfirm(values){
      console.log('values',values);
      this.area = values
				.filter((item) => !!item)
				.map((item) => item.name)
				.join('-')
      this.userInfo.regionCode = values[values.length - 1].code
      // this.userInfo.address = values[values.length - 1].code
			this.showArea = false
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}`;
    },
    onMonthRangeConfirm(date){
      const [start, end] = date;
      this.showMonthRangePicker = false;
      this.userInfo.cvalidity = `${this.formatDate(start)} - ${this.formatDate(end)}`;
    },
    nameValidator(val) {
      return !!this.userInfo.name;
    },
    validator(val) {
      const isPhone = /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/
      return isPhone.test(val);
    },
    postValidator(val){
      const isPostalcode = /^[1-9][0-9]{5}(?!\d)$/;
      return isPostalcode.test(val);
    },
    cancelHandle() {
      this.$router.go(-1)
    },
    //保存
    saveHandle() {
      this.$refs.validateForm
        .validate()
        .then(() => {
          // console.log(this.userInfo);
          this.$api.user.jiaotongSave(this.userInfo).then((res) => {
            if (res.code == 0 && res.success) {
              this.$toast({
                message: "保存成功",
              });
              this.$router.go(-1)
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.$toast({
            message: error[0].message,
            className: "errorTY",
          });
        });
    },
  },
};
</script>


<style lang="stylus" scoped>
.jiaotong-img{
  img{
    width:320px;
    height: 320px;
  }
}
.editProfileNew {
  // height: 100vh;
  background: #f5f6fa;
  overflow: auto;

  .photo_box {
    position: relative;
    width: 200px;
    height: 280px;
    border-radius: 10px;
    overflow: hidden;
  }

  .my_photo {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    img {
      width: 100%;
      height: 100%;
    }

    .tips {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 200px;
      height: 56px;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .re_uploadImg {
      width: 112px;
      height: 28px;
    }
  }

  .file_box {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #f7f8fa;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .file {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .space {
    height: 16px;
    width: 100%;
  }

  .handle_btn {
    width: 750px;
    height: 112px;
    background: #FFFFFF;
    box-shadow: 0px 1px 0px 0px #EAEAEA;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 48px;

    .cancel_btn {
      width: 332px;
      height: 88px;
      border-radius: 50px;
      border: 1px solid #1972FF;
      margin-right: 26px;
      color: #1972FF;
      font-size: 32px;
    }

    .save_btn {
      width: 332px;
      height: 88px;
      background: #1972FF;
      border-radius: 50px;
      font-size: 32px;
      color: #FFFFFF;
    }
  }
}
</style>
<style lang="stylus">
.editProfileNew {
  .van-uploader__wrapper {
    width: 100%;
    height: 100%;

    .van-uploader__upload {
      width: 100%;
      height: 100%;
      margin: 0;
    }
  }

  .van-cell {
    min-height: 2.773rem;
    padding-left: 1.2rem;
    padding-right: 0.8rem;
    display: flex;
    align-items: center;
  }

  .van-cell--required::before {
    left: 0.8rem;
  }

  .van-cell.photo_wrap {
    align-items: flex-start;
    padding-top: 0.96rem;
    padding-bottom: 1.066rem;
  }

  .van-cell.block_field {
    display: block;
    padding-top: 0.8rem;
    padding-bottom: 0.9rem;

    .radio_group {
      margin-top: 0.9rem;
    }
  }
}

.van-toast.errorTY {
  background-color: #FF5758 !important;
}
</style>